import * as Web from '/js/lib/webact.js';

import * as ProgressSaver from '../../progress-saver.js';

import '../play-button/play-button.js';
import '../episode-progress-indicator/episode-progress-indicator.js';

function PodcastEpisodeRowItem() {
  const { html, css, $, postRender } = this;

  html`
    <li>
      <slot name="image"></slot>
      <div class="left">
        <div class="top">
          <h4>
            <slot name="title"></slot>
          </h4>
        </div>
        <div class="bottom">
          <slot name="date"></slot> · <slot name="duration"></slot>
        </div>
      </div>
      <div class="right">
        <episode-progress-indicator></episode-progress-indicator>
        <slot name="play-button"></slot>
      </div>
    </li>
  `;

  css`
    :host {
      contain: layout;
      content-visibility: auto;
      contain-intrinsic-size: 0 75.88px;
      overflow: hidden;
      box-sizing: border-box;
      width: 100%;
      display: block;
      font-size: 0.9rem;
    }

    ::slotted(episode-play-button) {
      padding: 1rem;
    }

    .played {
      opacity: 0.7;
      cursor: cell;
    }

    ::slotted(img) {
      display: block;
      width: 48px;
      height: 48px;
      margin-right: calc(1.61803398875rem / 2);
      border-radius: calc(1.61803398875rem / 4);
      overflow: hidden;
      contain: strict;
    }

    li {
      display: flex;
      flex-direction: row;
      background-color: var(--bg-color);
      transition: background-color 250ms ease;
      padding: calc(1.61803398875rem / 2);
      align-items: center;
    }

    li:hover {
      background-color: var(--hover-bg);
    }

    .left {
      flex: 1;
      overflow: hidden;
    }

    .right {
      margin-left: 1rem;
      display: flex;
      align-items: center;
    }

    .right episode-progress-indicator {
      margin-right: 0.5em;
      transform: translateY(-1px);
    }

    play-button {
      color: white;
    }

    li h4 {
      font-weight: 500;
      margin: 0;
      margin-bottom: calc(1.61803398875rem / 6);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .bottom {
      font-size: calc(1.61803398875rem / 2);
      color: var(--sub-title-colour);
    }

    slot[name="audio"] {
      display: none;
    }

    :host(.show-player) slot[name="audio"] {
      display: block;
      position: fixed;
      bottom: 50px;
      width: 100%;
      left: 0;
      right: 0;
    }
  `;

  postRender(async () => {
    const progress = await ProgressSaver.getEpisodeProgress($().getAttribute('progress-id'));

    if (progress === 1) {
      $().classList.add('played');
    }

    $('episode-progress-indicator').setAttribute('value', progress);
  });
}

export default Web.registerFunctionComponent(PodcastEpisodeRowItem, {
  name: 'podcast-episode-row-item'
});
